import { Button, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDemoConfig } from '../../infrastructure/context/DemoConfigContext';
import NewAnalysisModal from './NewAnalysisModal';

interface Props {
  isCnv: boolean;
}

const NewAnalysis: React.FC<Props> = ({ isCnv }) => {
  const { t } = useTranslation();
  const { canCreateAnalysis, analysisBlockedMessage } = useDemoConfig();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={analysisBlockedMessage || ''}>
        <span>
          <Button variant="contained" onClick={handleOpen} disabled={!canCreateAnalysis}>
            {t('study.newAnalysis')}
          </Button>
        </span>
      </Tooltip>
      {open && <NewAnalysisModal handleClose={handleClose} isCnv={isCnv} />}
    </>
  );
};

export default NewAnalysis;
